"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PriceView = exports.PriceUIType = void 0;
var React = require("react");
var styled_1 = require("./styled");
var PriceUIType;
(function (PriceUIType) {
    PriceUIType[PriceUIType["Small"] = 0] = "Small";
    PriceUIType[PriceUIType["Middle"] = 1] = "Middle";
    PriceUIType[PriceUIType["Large"] = 2] = "Large";
})(PriceUIType = exports.PriceUIType || (exports.PriceUIType = {}));
exports.PriceView = function (props) {
    var price = props.price, originPrice = props.originPrice, _a = props.type, type = _a === void 0 ? PriceUIType.Middle : _a;
    return (React.createElement(styled_1.PriceBox, { type: type },
        React.createElement(styled_1.CurrentPrice, { className: "current" }, price),
        price !== originPrice && React.createElement(styled_1.OriginPrice, { className: "origin" }, originPrice)));
};
